import { getCurrentSession } from "../../lib/authentication";

export const fetch = params =>
  getCurrentSession().then(({ accessToken }) =>
    apigClient
      .ratingsTypeGet(
        params,
        {},
        {
          headers: {
            Authorization: accessToken,
          },
        },
      )
      .then(resp => resp.data)
      .catch(e => {
        throw e.data;
      })
  )
